import { onSnapshot, query, where } from "firebase/firestore";
import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import AssinaturaDb from "../db/assinaturaDb";
import Assinatura, { SituacaoAssinatura } from "../models/assinatura";
import { useUsuario } from "./usuarioProvider";

export const AssinaturaProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { usuario: { id } = { id: undefined } } = useUsuario();
  const [assinatura, setAssinatura] = useState<Assinatura | undefined>();
  useEffect(() => {
    if (!!id)
      return onSnapshot(
        query(
          new AssinaturaDb().collection({
            usuarioId: id,
            assinaturaId: "",
          }),
          where("status", "in", [
            SituacaoAssinatura.ACTIVE,
            SituacaoAssinatura.TRIALING,
          ])
        ),
        (assinaturaSnapshot) => {
          if (!assinaturaSnapshot.empty) {
            setAssinatura(assinaturaSnapshot.docs[0].data());
          } else {
            setAssinatura(undefined);
          }
        }
      );
  }, [id]);
  return (
    <AssinaturaContext.Provider value={assinatura}>
      {children}
    </AssinaturaContext.Provider>
  );
};

const AssinaturaContext = createContext<Assinatura | undefined>(undefined);

export const useAssinatura = () => {
  const context = useContext(AssinaturaContext);
  return context;
};
